import Accordion, {
  AccordionItemDesktop,
  AccordionItemMobile,
} from '../common/Accordion';
import type { AccordionData } from './useConsent';

interface ConsentAccordionSectionProps {
  data: AccordionData;
  isOpen: boolean;
  onToggle: () => void;
  variant: 'desktop' | 'mobile';
}

const ConsentAccordionSection = ({
  data,
  isOpen,
  onToggle,
  variant,
}: ConsentAccordionSectionProps) => {
  const isDesktop = variant === 'desktop';
  const AccordionItem = isDesktop ? AccordionItemDesktop : AccordionItemMobile;

  return (
    <Accordion
      icon={data.icon}
      title={data.title}
      isOpen={isOpen}
      onToggle={onToggle}
    >
      <div className={`flex flex-col ${isDesktop ? 'gap-4' : 'gap-3'}`}>
        {data.items.map((item, index) => (
          <AccordionItem
            key={index}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </Accordion>
  );
};

export default ConsentAccordionSection;
